import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';

import { forkJoin } from 'rxjs';

import { AlertService } from '../../services/alert.service';
import { FirmwareService } from '../../services/firmware.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'firmware-v2',
    templateUrl: './firmware-v2.component.html',
    styleUrls: ['./firmware-v2.component.scss']
})
export class FirmwareV2Component implements OnInit, OnDestroy, OnChanges {

    @Input()
    product: any;

    newFirmwareVisible!: boolean;

    newFirmwareFormGroup!: FormGroup;

    newFirmwareSelectedFile!: File | null;

    clients!: any[];

    items!: any[];

    lastFirmwaresForTestUsers: any;

    lastFirmwaresForBetaUsers: any;

    lastFirmwaresForEndUsers: any;

    firmwares!: any[];

    selectedFirmwareToEdit: any;

    editFirmwareFormGroup: any;

    deleteFirmwareVisibles: any = {};

    firmwareCompare = (a: any, b: any) => {
        let convertVersion = (s: string) => s.split('.').map(s => parseInt(s, 10));
        let compareVersion = (u: any, v: any) => {
            let i = 0;
            while (i < Math.max(u.length, v.length)) {
                if (i < u.length && i < v.length) {
                    let compareTo = -u[i] + v[i];
                    if (compareTo < 0) {
                        return -1;
                    } else if (compareTo > 0) {
                        return 1;
                    }
                } else if (i < u.length) {
                    return -1;
                } else if (i < v.length) {
                    return 1;
                }
                i++;
            }
            return 0;
        };
        if (a.item != b.item) {
            return a.item.localeCompare(b.item);
        } else {
            return compareVersion(convertVersion(a.version), convertVersion(b.version));
        }
    };

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private firmwareService: FirmwareService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.newFirmwareFormGroup = this.formBuilder.group({
            newFirmwareItemSelect: [null, Validators.required],
            newFirmwareFileInput: [null, Validators.required],
            newFirmwareVersionInput: [null, Validators.required],
            newFirmwareMinVersionInput: [null, /*Validators.required*/]
        });
        this.newFirmwareSelectedFile = null;
    }

    ngOnDestroy() {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.refreshFirmwares();
    }

    displayNewFirmwareFormGroup() {
        if (this.newFirmwareFormGroup) {
            this.newFirmwareFormGroup.reset();
        }
        this.newFirmwareSelectedFile = null;
        this.newFirmwareVisible = true;
        this.cancelSelectedFirmwareToEdit();
    }

    hideNewFirmwareFormGroup() {
        if (this.newFirmwareFormGroup) {
            this.newFirmwareFormGroup.reset();
        }
        this.newFirmwareSelectedFile = null;
        this.newFirmwareVisible = false;
    }

    refreshFirmwares() {
        this.deleteFirmwareVisibles = {};
        this.hideNewFirmwareFormGroup();
        this.cancelSelectedFirmwareToEdit();
        this.getFirmwares();
    }

    getFirmwares() {
        this.progressIndicatorService.progress = true;
        forkJoin([
            this.firmwareService.getV2FirmwaresProductClients(this.product.name),
            this.firmwareService.getV2FirmwaresProductItems(this.product.name),
            this.firmwareService.getV2FirmwaresProductVersionsForTestUsers(this.product.name),
            this.firmwareService.getV2FirmwaresProductVersionsForBetaUsers(this.product.name),
            this.firmwareService.getV2FirmwaresProductVersionsForEndUsers(this.product.name),
            this.firmwareService.getV2FirmwaresProductVersions(this.product.name)
        ]).subscribe({
            next: ([clients, items, lastFirmwaresForTestUsers, lastFirmwaresForBetaUsers, lastFirmwaresForEndUsers, firmwares]) => {
                console.log('FirmwareV2Component.getFirmwares.firmwareService.getV2FirmwaresProductClients.value', clients);
                console.log('FirmwareV2Component.getFirmwares.firmwareService.getV2FirmwaresProductItems.value', items);
                console.log('FirmwareV2Component.getFirmwares.firmwareService.getV2FirmwaresProductVersionsForTestUsers.value', lastFirmwaresForTestUsers);
                console.log('FirmwareV2Component.getFirmwares.firmwareService.getV2FirmwaresProductVersionsForBetaUsers.value', lastFirmwaresForBetaUsers);
                console.log('FirmwareV2Component.getFirmwares.firmwareService.getV2FirmwaresProductVersionsForEndUsers.value', lastFirmwaresForEndUsers);
                console.log('FirmwareV2Component.getFirmwares.firmwareService.getV2FirmwaresProductVersions.value', firmwares);
                this.progressIndicatorService.progress = false;

                for (let lastFirmwares of [lastFirmwaresForTestUsers, lastFirmwaresForBetaUsers, lastFirmwaresForEndUsers]) {
                    lastFirmwares.firmwares = lastFirmwares.firmwares.map((last: any) => {
                        return firmwares.firmwares.find((f: any) => last.product == f.product && last.item == f.item && last.version == f.version);
                    });
                }

                for (let firmware of firmwares.firmwares) {
                    let requirement = firmware.requirements.items.find((r: any) => r.item == firmware.item && r.operator == 'GE');
                    firmware.minVersion = requirement ? requirement.version : null;
                }

                this.clients = clients.clients;
                this.items = items.items;
                this.lastFirmwaresForTestUsers = lastFirmwaresForTestUsers;
                this.lastFirmwaresForBetaUsers = lastFirmwaresForBetaUsers;
                this.lastFirmwaresForEndUsers = lastFirmwaresForEndUsers;
                this.firmwares = firmwares.firmwares;

                this.clients.sort();
                this.items.sort();
                this.lastFirmwaresForTestUsers.firmwares.sort(this.firmwareCompare);
                this.lastFirmwaresForBetaUsers.firmwares.sort(this.firmwareCompare);
                this.lastFirmwaresForEndUsers.firmwares.sort(this.firmwareCompare);
                this.firmwares.sort(this.firmwareCompare);

            },
            error: (error: any) => {
                console.log('FirmwareV2Component.getFirmwares.firmwareService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    newFirmwareFileInputChange(event: any) {
        let file: File = event.target.files[0];
        this.newFirmwareSelectedFile = file;
    }

    uploadNewFirmware() {

        let formGroup: FormGroup = this.newFirmwareFormGroup;
        let item: string = formGroup.value.newFirmwareItemSelect;
        let version: string = formGroup.value.newFirmwareVersionInput;
        let minVersion: string = formGroup.value.newFirmwareMinVersionInput;
        let file: File | null = this.newFirmwareSelectedFile;
        if (file == null) return;

        this.progressIndicatorService.progress = true;
        this.firmwareService.uploadV2Firmware(this.product.name, item, version, minVersion, file).subscribe({
            next: (value: any) => {
                console.log('FirmwareV2Component.uploadNewFirmware.firmwareService.uploadV2Firmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2Component.uploadNewFirmware.firmwareService.uploadV2Firmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    toValidateFirmware(firmwareId: string) {
        this.progressIndicatorService.progress = true;
        this.firmwareService.toValidateV2Firmware(firmwareId).subscribe({
            next: (value: any) => {
                console.log('FirmwareV2Component.toValidateFirmware.firmwareService.toValidateV2Firmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2Component.toValidateFirmware.firmwareService.toValidateV2Firmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    validateFirmware(firmwareId: string) {
        this.progressIndicatorService.progress = true;
        this.firmwareService.validateV2Firmware(firmwareId).subscribe({
            next: (value: any) => {
                console.log('FirmwareV2Component.validateFirmware.firmwareService.validateV2Firmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2Component.validateFirmware.firmwareService.validateV2Firmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    publishFirmware(firmwareId: string) {
        this.progressIndicatorService.progress = true;
        this.firmwareService.publishV2Firmware(firmwareId).subscribe({
            next: (value: any) => {
                console.log('FirmwareV2Component.publishFirmware.firmwareService.publishV2Firmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2Component.publishFirmware.firmwareService.publishV2Firmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    displaySelectedFirmwareToEdit(firmwareId: string) {
        let firmware: any = this.firmwares.find((f: any) => f.id == firmwareId);
        if (firmware) {
            this.selectedFirmwareToEdit = firmware;
            this.editFirmwareFormGroup = this.formBuilder.group({
                editFirmwareItemInput: [{ value: firmware.item, disabled: true }, /*Validators.required*/],
                editFirmwareFileInput: [{ value: firmware.filename, disabled: true }, /*Validators.required*/],
                editFirmwareVersionInput: [{ value: firmware.version, disabled: false }, Validators.required],
                editFirmwareMinVersionInput: [{ value: firmware.minVersion, disabled: false }, /*Validators.required*/],
            });
        } else {
            this.selectedFirmwareToEdit = null;
            this.editFirmwareFormGroup = null;
        }
        this.hideNewFirmwareFormGroup();
    }

    updateSelectedFirmwareToEdit() {

        let firmwareId: string = this.selectedFirmwareToEdit.id;
        let item: string = this.selectedFirmwareToEdit.item;

        let formGroup: FormGroup = this.editFirmwareFormGroup;
        let version: string = formGroup.value.editFirmwareVersionInput;
        let minVersion: string = formGroup.value.editFirmwareMinVersionInput;

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.firmwareService.updateV2FirmwareVersion(firmwareId, version),
            this.firmwareService.updateV2FirmwareRequirements(firmwareId, item, minVersion)
        ]).subscribe({
            next: ([version, requirements]) => {
                console.log('FirmwareV2Component.updateSelectedFirmwareToEdit.firmwareService.updateV2FirmwareVersion.value', version);
                console.log('FirmwareV2Component.updateSelectedFirmwareToEdit.firmwareService.updateV2FirmwareRequirements.value', requirements);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.selectedFirmwareToEdit = null;
                this.editFirmwareFormGroup = null;
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2Component.updateSelectedFirmwareToEdit.firmwareService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    cancelSelectedFirmwareToEdit() {
        this.selectedFirmwareToEdit = null;
        this.editFirmwareFormGroup = null;
    }

    displayDeleteFirmware(firmwareId: string) {
        this.deleteFirmwareVisibles[firmwareId] = true;
        setTimeout(() => this.deleteFirmwareVisibles[firmwareId] = false, 3000);
    }

    deleteFirmware(firmwareId: string) {
        this.progressIndicatorService.progress = true;
        this.firmwareService.deleteV2Firmware(firmwareId).subscribe({
            next: (value: any) => {
                console.log('FirmwareV2Component.deleteFirmware.firmwareService.deleteV2Firmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2Component.deleteFirmware.firmwareService.deleteV2Firmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }
}
